import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
type TechnicalItem = {
  label: string;
  to: string;
  children?: TechnicalItem[];
};
type TechnicalGroup = {
  label: string;
  items: TechnicalItem[];
};
export const technicalGroups: TechnicalGroup[] = [{
  label: 'Drill Bits',
  items: [{
    label: 'Tap Drill and Thread Engagement Calculator',
    to: '/technical-info/drill-bits/tap-drill-calculator'
  }, {
    label: 'Drill And Tap Size Chart',
    to: '/technical-info/drill-bits/tap-and-drill-size-charts',
    children: [{
      label: 'NPT Tap Drill Chart',
      to: '/technical-info/drill-bits/npt-tap-drill-chart.html'
    }, {
      label: 'Metric Drill And Tap Chart',
      to: '/technical-info/drill-bits/metric-tap-drill-chart.html'
    }, {
      label: 'Inch Tap Drill Size Chart',
      to: '/technical-info/drill-bits/standard-tap-drill-chart.html'
    }, {
      label: 'Screw And Drill Size Chart',
      to: '/technical-info/drill-bits/screw-drill-size-chart.html'
    }]
  }]
}, {
  label: 'End Mills',
  items: [{
    label: 'End Mill Sizes',
    to: '/technical-info/end-mills/end-mill-sizes'
  }, {
    label: 'End Mill Dimensions',
    to: '/technical-info/end-mills/dimensions-geometry'
  }, {
    label: 'Speeds And Feeds Charts',
    to: '/technical-info/end-mills/feeds-and-speeds-carbide'
  }, {
    label: 'Speeds And Feeds Calculator',
    to: '/technical-info/end-mills/feeds-and-speeds-calculator'
  }]
}, {
  label: 'Burs',
  items: []
}];
export function TechnicalMenuDesktop() {
  return <li className="group relative" data-id="element-688" data-mp="2rr6k8hll1nyf">
      <span className="hover:text-brand-red transition-colors flex items-center gap-1 cursor-default" data-id="element-689" data-mp="2rs7vam2lmag5">
        TECHNICAL INFO
        <ChevronDown className="w-3.5 h-3.5" data-id="element-690" data-mp="pz1v1dvgx4re" />
      </span>
      <div className="absolute top-full left-0 w-60 bg-white border border-gray-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible transition-all z-50" data-id="element-691" data-mp="pzjns0ix90uk">
        <ul className="py-2 text-sm font-normal" data-id="element-692" data-mp="1xyh0igx76cfa">
          {technicalGroups.map(group => <li key={group.label} className="group/tech relative" data-id="element-693" data-mp="1y0tp3cxgnl1b">
              <div className="flex items-center justify-between px-4 py-2 font-semibold text-black hover:bg-brand-gray" data-id="element-694" data-mp="1txf8ol5m12nc">
                <span data-id="element-695" data-mp="1p05deovjhwrl">{group.label}</span>
                {group.items.length > 0 && <ChevronRight className="w-3.5 h-3.5 text-gray-400" data-id="element-696" data-mp="2lnjrwghmvjmz" />}
              </div>
              {group.items.length > 0 && <div className="absolute top-0 left-full w-72 bg-white border border-gray-200 shadow-lg opacity-0 invisible group-hover/tech:opacity-100 group-hover/tech:visible group-focus-within/tech:opacity-100 group-focus-within/tech:visible transition-all" data-id="element-697" data-mp="2hou7w523b3ud">
                  <ul className="py-2" data-id="element-698" data-mp="35dlr46xpcbv0">
                    {group.items.map(item => <li key={item.label} className={item.children ? 'group/item relative' : undefined} data-id="element-699" data-mp="30kkanuhuk49b">
                        <div className="flex items-center gap-2 px-4 py-2 hover:bg-brand-gray" data-id="element-700" data-mp="37y1lg3b9wbhs">
                          <Link to={item.to} className="flex-grow text-brand-red hover:text-red-700" data-id="element-701" data-mp="3cw3gznpvy3a5">{item.label}</Link>
                          {item.children && <ChevronRight className="w-3.5 h-3.5 text-gray-400" data-id="element-702" data-mp="3hx0u3lw1g74s" />}
                        </div>
                        {item.children && <div className="absolute top-0 left-full w-64 bg-white border border-gray-200 shadow-lg opacity-0 invisible group-hover/item:opacity-100 group-hover/item:visible group-focus-within/item:opacity-100 group-focus-within/item:visible transition-all" data-id="element-703" data-mp="3qujnbdju5rrr">
                            <ul className="py-2" data-id="element-704" data-mp="9f4gy461u4a1">
                              {item.children.map(child => <li key={child.label} data-id="element-705" data-mp="dgq02796feso"><Link to={child.to} className="block px-4 py-2 text-brand-red hover:bg-brand-gray" data-id="element-706" data-mp="dh7v50k3rmz0">{child.label}</Link></li>)}
                            </ul>
                          </div>}
                      </li>)}
                  </ul>
                </div>}
            </li>)}
        </ul>
      </div>
    </li>;
}